// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"948cc2ec","436":"2193e403","453":"f394a27d","501":"7d12f8c1","606":"973e1268","821":"cf852e20","925":"4a3574d5","969":"a711edfd"}[chunkId] + ".chunk.js";
};